<template>
  <v-app>
    <v-main>
      <v-container width="600" style="margin-top: 30px">
        <h2 style="font-size: 28px">Perguntas frequentes</h2>
        <p class="sub-title">Escolha a categoria que você tem alguma dúvida</p>
        <v-card
          class="mx-left card"
          width="100%"
          style="margin-top: 20px"
          v-for="item in faq"
          :key="item.title"
          :value="true"
        >
          <v-list style="padding: 0">
            <v-list-group no-action>
              <template v-slot:activator>
                <v-list-item-title
                  class="d-flex align-center align-items-center text-align-center"
                >
                  <img
                    style="max-width: 25px; margin: 10px"
                    src="../assets/icon_ondivan.png"
                  />
                  {{ item.title }}</v-list-item-title
                >
              </template>

              <v-list-group
                v-model="question.active"
                v-for="question in item.questions"
                :key="question.title"
                no-action
                sub-group
              >
                <template v-slot:activator>
                  <v-list-item-title style="color-darkGray">{{
                    question.title
                  }}</v-list-item-title>
                </template>
                <v-list-item
                  v-for="content in [question.content]"
                  :key="content"
                  style="padding: 20px"
                >
                  <template>
                    <v-list-item-content class="card-content">
                      <v-list-item-title
                        class="card-text"
                        v-html="content"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-group>
            </v-list-group>
          </v-list>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import Api from '../services/httpClient';
export default {
  name: 'BaseNav',
  props: {
    name: {
      type: String,
      required: true,
    },
    URL: String,
  },
  data: () => ({
    faq: [],
  }),
  created() {
    Api.get('/faq/')
      .then((res) => {
        const questions = res.data;
        questions;
        console.log(res.data);
        this.faq = [
          {
            title: 'Paciente',
            questions: questions.filter((question) => {
              return question.type === 'patient';
            }),
          },
          {
            title: 'Psicologo',
            questions: questions.filter((question) => {
              return question.type === 'psychologist';
            }),
          },
          {
            title: 'Terapeuta Chefe',
            questions: questions.filter((question) => {
              return question.type === 'patient_psychologist';
            }),
          },
        ];
      })
      .catch((err) => console.log(err));
  },
};
</script>
<style scoped>
.sub-title {
  color: rgba(0, 0, 0, 0.5);
  padding: 5px 0;
  font-size: 20px;
  margin-bottom: 20px;
}

.card-content {
  padding: 0;
}
.card-text {
  white-space: normal;
  width: 100%;
  line-height: 1.4;
  padding: 20px;
  margin: 0;
}
</style>
